import { ADMIN_API, BASE_API, CLIENT_API , CLIENT_APP_API } from "@/config";

export const apiConstants = {
  home: `${ADMIN_API}/dashboard`,
  town: `${BASE_API}/towns`,  // Municipios
  provinces: `${BASE_API}/provinces`,
  phonePrefix: `${BASE_API}/paises`,
  staying: `${CLIENT_API}/events-clients-stayings`,
  plan: `${BASE_API}/plans`,
  parking: `${BASE_API}/parkings`,
  parkingPlan: `${BASE_API}/parkings-plans`,
  product:  `${CLIENT_API}/products`, //`/api/client/products/active`,
  events: `${CLIENT_API}/events`,
  // parkingService: `${ADMIN_API}/parkings-services`,
  parkingServiceBase: `${BASE_API}/parkings-services`,
  service: `${BASE_API}/services`,
  group: `${ADMIN_API}/groups`,
  parkingProduct: `${CLIENT_API}/parkings-plans-clients`,
  spotsType: `${ADMIN_API}/spots-types`, // TODO: Endpoint pendiente, solo tipo moto(de momento), no urgente


  billingData: `${CLIENT_API}/clients-billing-data`,  //billing  clients-billing-data
  client: `${CLIENT_API}/clients`,
  payment: `${CLIENT_API}/payments`,
  clientApp:`${CLIENT_APP_API}/clients`, // api/app/clients
  creditCards: `${CLIENT_API}/clients/credit-cards`,  // api/base/credit-cards   /api/clientes/credit-cards
  invoices: `${CLIENT_API}/invoices`,
  walletTransaction: `${CLIENT_API}/wallets-transactions`,
  parkingImages: `${BASE_API}/parkings-images`,

}
